import Vue from 'vue'
import VueApollo from 'vue-apollo'
import VueImagePreloader from 'vue-image-preloader'
import Notifications from 'vue-notification'
import App from './App.vue'
import EventBus from './util/event-bus'
import clients from './apollo'

Vue.config.productionTip = false

Vue.use(EventBus)
Vue.use(VueApollo)
Vue.use(VueImagePreloader)
Vue.use(Notifications)

const apolloProvider = new VueApollo({
  clients,
  defaultClient: clients.api,
  defaultOptions: {
    $loadingKey: 'loading'
  }
})

new Vue({
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
